export default {
  page_title: 'Consommations',
  page_description: 'Suivre l\'utilisation des ressources consommables',
  editTitle: 'Modifier la Consommation',
  consume_resource: 'Consommer une Ressource',
  resource: 'Ressource',
  user: 'Utilisateur',
  quantity_consumed: 'Quantité Consommée',
  consumed_date: 'Date de Consommation',
  notes: 'Notes',
  notes_placeholder: 'Entrez des notes sur cette consommation...',
  quantity_to_consume: 'Quantité à Consommer',
  available_quantity: 'Quantité Disponible',
  consume: 'Consommer',
  consumed_successfully: 'Ressource consommée avec succès',
  invalid_quantity: 'La quantité doit être supérieure à 0',
  insufficient_quantity: 'Quantité insuffisante disponible',
  unknown_resource: 'Ressource Inconnue',
  unknown_user: 'Utilisateur Inconnu',
  units: 'unités'
};
